import { render, staticRenderFns } from "./auth-by-code.vue?vue&type=template&id=18119d27&scoped=true&"
import script from "./auth-by-code.vue?vue&type=script&lang=js&"
export * from "./auth-by-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18119d27",
  null
  
)

export default component.exports